import React from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import Layout from '../Layout';
import Button from '../Button';
import { SuccessContent } from '../Login/Login.styles';
import { useLocation, useNavigate } from 'react-router-dom';

const Successful = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;
  console.log(from);

  const successText = from === 'signup' ? 'Account Created' : 'Password Reset';

  return (
    <>
      <Layout showTemplate={false}>
        <OnboardingTemplate>
          <div className="text-content">
            <SuccessContent>
              <strong className="title">
                {successText}
                <br /> Successful!
              </strong>
              <Button width="100%" onClick={() => navigate('/')}>
                Login Again
              </Button>
            </SuccessContent>
          </div>
        </OnboardingTemplate>
      </Layout>
    </>
  );
};

export default Successful;
